import free_email_provider_set from './free_email_provider_domains'

export const isCompanyEmail = (email) => {
  if (!email || typeof email !== 'string') return false

  const fields = email.trim().toLowerCase().split('@')
  const domain = fields[1]

  if (!domain) return false

  return !free_email_provider_set.has(domain)
}
